module.exports = __webpack_public_path__ + "static/media/arrow-alt-circle-left.dcb28c09.svg";